import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { Link } from "react-router-dom";
import detector from "detector";

import routing from "../../../../routing";
import Button from "../../../../components/BigWhiteButton";
import { amazonHost } from "../../../../paths";

import { ButtonWrapper } from "../Hero/styles";

import {
    Section,
    Ribbon,
    ComingSoon,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const isFirefox = process.env.WEBPACK ? detector.browser.name === "firefox" : false;

class Features extends Component<IProps> {
    state = { rotate: "", reversedRotate: "", showTransformables: false };
    componentDidMount() {
        window.addEventListener("resize", this.resize);
        setTimeout(this.resize, 100);
        this.setState({ showTransformables: true });
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }
    resize = () => {
        if (window.innerWidth < 768) {
            let deg = (Math.sin(60 / window.innerWidth) * 180) / Math.PI;
            this.setState({ rotate: `rotate(${deg}deg)`, reversedRotate: `rotate(${-deg}deg)` });
        } else {
            this.setState({ rotate: "", reversedRotate: "" });
        }
    };
    render() {
        const { user } = this.props;
        const { rotate, reversedRotate, showTransformables } = this.state;
        return (
            <Section>
                <Ribbon className={"Ribbon1"}>
                    <div className={"RibbonWrapper"}>
                        <div className={"Container"}>
                            <h3>
                                <FormattedMessage {...messages.a1_h3} />
                            </h3>
                            <p>
                                <FormattedHTMLMessage {...messages.a1_d} />
                            </p>
                        </div>
                        <img
                            className={isFirefox ? "Firefox" : undefined}
                            src={amazonHost + "landing/memory-article1-new.jpg"}
                            alt="happy singing choir with conductor"
                        ></img>
                    </div>
                    {showTransformables && (
                        <>
                            <div className={"UpperRibbon"}></div>
                            <div className={"LowerShadow"} style={{ transform: rotate }}></div>
                        </>
                    )}
                </Ribbon>
                <Ribbon className={"Ribbon2"}>
                    <div className={"RibbonWrapper"}>
                        <div className={"Container"}>
                            <h3>
                                <FormattedMessage {...messages.a2_h3} />
                            </h3>
                            <p>
                                <FormattedHTMLMessage {...messages.a2_d} />
                            </p>
                        </div>
                        <img
                            src={amazonHost + "landing/memory-article2-new.png"}
                            alt="listening"
                        ></img>
                    </div>
                    {showTransformables && (
                        <>
                            <div className={"UpperRibbon"}></div>
                            <div className={"LowerShadow"} style={{ transform: reversedRotate }}></div>
                        </>
                    )}
                </Ribbon>
                <Ribbon className={"Ribbon3"}>
                    <div className={"RibbonWrapper"}>
                        <div className={"Container"}>
                            <h3>
                                <FormattedMessage {...messages.a3_h3} />
                            </h3>
                            <p>
                                <FormattedMessage {...messages.a3_d} />
                            </p>
                        </div>
                        <ComingSoon>
                            <FormattedMessage {...messages.a3_s} />
                        </ComingSoon>
                        {/* <img src={dev ? (host + "assets/local/article3-1000.png") : (amazonHost + "landing/article3-1000.png")}
                            sizes={"(min-width: 1200px) 682px, (min-width:992px) 515px, (min-width: 768px) 485px, 421px"}
                            srcSet={(dev ? (host + "assets/local/article3-1000.png") : (amazonHost + "landing/article3-1000.png")) + " 1000w," +
                                (dev ? (host + "assets/local/article3-682.png") : (amazonHost + "landing/article3-682.png")) + " 682w," +
                                (dev ? (host + "assets/local/article3-485.png") : (amazonHost + "landing/article3-485.png")) + " 485w"
                            }
                            alt="teacher using tablet for work"></img> */}
                    </div>
                    {showTransformables && (
                        <>
                            <div className={"UpperRibbon"}></div>
                            <div className={"LowerShadow"} style={{ transform: rotate }}></div>
                        </>
                    )}
                </Ribbon>
                <Ribbon className={"Ribbon4"}>
                    <div className={"RibbonWrapper"}>
                        <p>
                            <FormattedHTMLMessage {...messages.join} />
                        </p>
                        <ButtonWrapper>
                            <Link
                                to={
                                    "/" +
                                    routing.memory +
                                    "/" +
                                    (!user ? routing.signup : user.loggedIn ? routing.choirs : routing.signup)
                                }
                            >
                                <Button className={cn("button", "button--pretty")}>
                                    <FormattedMessage {...messages.start} />
                                </Button>
                            </Link>
                        </ButtonWrapper>
                    </div>
                    {showTransformables && <div className={"UpperRibbon"}></div>}
                </Ribbon>
            </Section>
        );
    }
}

export default Features;
